var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('img',{attrs:{"src":'/img/Signup-Finish.png'}}),_c('span',{staticClass:"title"},[_vm._v("Congratulations")]),_c('div',{staticClass:"login-content"},[_c('button',{staticClass:"button-default big finish",on:{"click":function($event){return _vm.finish()}}},[_c('span',[_vm._v("Go to Dashboard")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }